<template>
  <li class="events-item" role="presentation">

    <a href="#" class="relative flex justify-between py-6 text-base font-medium border-b dropdown-toggle border-gray-text" data-toggle-class="is-open" data-toggle-target="#mobile-menu-events, .main-menu" aria-expanded="false" data-toggle-group="menu-accordions" data-toggle-escape>
      Events
      <span class="inline-block text-base">
        <svg class="text-2xl icon icon-chevron-right" aria-hidden="true"><use xlink:href="#icon-chevron-right"></use></svg>
      </span>
    </a>

    <div class="items-stretch justify-between child-dropdown dropdown-menu menu-wrapper events-menu" id="mobile-menu-events"aria-label="item-events">

      <div class="menu-title">
        <div class="flex items-center justify-between inner-container">
          <button class="back" data-toggle-trigger-off="#mobile-menu-events"><svg class="mr-2 text-xl icon icon-left-arrow" aria-hidden="true"><use xlink:href="#icon-left-arrow"></use></svg> <span class="text-sm">Back</span></button>
          <span class="text-base font-medium">Events</span>
          <button type="button" class="flex-initial navbar-toggle lg:hidden is-open" data-toggle-trigger-off=".primary-nav--mobile">
            <span class="navbar-toggle-icon"></span>
            <span class="sr-only">Close Menu</span>
          </button>
        </div>
      </div>

      <div class="py-5 bg-gray-light-gray">

        <div class="flex items-center justify-between inner-container">

          <p class="flex-initial" tabindex="0">

            <svg class="mr-2 text-xl icon icon-calendar" aria-hidden="true"><use xlink:href="#icon-calendar"></use></svg>

            <span>{{ displayDate() }}</span>

          </p> <!-- /.flex-initial -->

          <button class="text-sm font-medium underline hover:no-underline" id="mobile-item-event-update" data-toggle-class="is-sub-open" data-toggle-target="#mobile-menu-events-update, #mobile-menu-events" aria-expanded="false" data-toggle-group="mobile-sub-menu-accordions">Edit <span class="sr-only">event date</span></button>

        </div> <!-- /.inner-container -->

      </div> <!-- /.bg-gray-light-gray -->

      <div class="inner-container">

        <div class="events-list">


            <template v-if="isRunning">

              <p class="mt-6 text-center">Loading events...</p>

            </template>
            <template v-else>

              <ul v-if="events.length > 0" role="menu">

                <li v-for="(event, index) in events" :key="index" class="w-full" role="presentation">

                  <a :href="event.url" class="flex items-center justify-start py-6 border-b hover:underline border-gray-text" role="menuitem">

                    <div class="relative flex-shrink-0 w-24 mr-5 overflow-hidden rounded-sm image-wrapper aspect-square" v-html="event.image">
                    </div> <!-- /.image-wrapper -->

                    <div class="flex-initial">

                      <p class="mb-3 hdg-6" v-if="event.location">{{ event.location }}</p>

                      <p class="text-lg font-medium leading-snug text-gray-charcoal">{{ event.name }}</p>

                    </div> <!-- /.flex-initial -->

                  </a> <!-- /.flex -->

                </li> <!-- /.w-full -->

              </ul>

              <template v-else>

                <p class="mt-6 text-center">No events for selected date.</p>

              </template>

            </template>

          </ul>

          <a :href="eventsArchiveUrl" class="mt-12 btn-black-border" role="menuitem">View All Events</a>

        </div> <!-- /.events-list -->

      </div> <!-- /.inner-container -->

      <div class="items-stretch justify-between subchild-dropdown dropdown-menu menu-wrapper level-three" id="mobile-menu-events-update" aria-label="item-events-update">

        <div class="menu-title">
          <div class="flex items-center justify-between inner-container">
            <button class="back" data-toggle-trigger-off="#mobile-menu-events-update"><svg class="mr-2 text-xl icon icon-left-arrow" aria-hidden="true"><use xlink:href="#icon-left-arrow"></use></svg> <span class="text-sm">Back</span></button>
            <span class="text-base font-medium">Events</span>
            <button type="button" class="flex-initial navbar-toggle lg:hidden is-open" data-toggle-trigger-off=".primary-nav--mobile">
              <span class="navbar-toggle-icon"></span>
              <span class="sr-only">Close Menu</span>
            </button>
          </div> <!-- /.inner-container -->
        </div> <!-- /.menu-title -->

        <div class="calendar-area calendar-area--mobile">

          <date-picker v-model="date" :min-date="new Date()" is-expanded trim-weeks is-required/>

        </div> <!-- /.calendar-area -->

        <div class="flex items-center justify-end mt-12 inner-container">

          <button class="inline-block mr-8 hover:underline" data-toggle-trigger-off="#mobile-menu-events-update" >Cancel</button>

          <button class="inline-block px-12 py-4 font-medium text-center transition-all duration-200 border border-black rounded-sm hover:border-gray-dark-charcoal hover:bg-gray-dark-charcoal hover:text-white" data-toggle-trigger-off="#mobile-menu-events-update" >Update</button>

        </div> <!-- /.mt-12 -->

      </div> <!-- /.subchild-dropdown -->

    </div> <!-- /.dropdown-menu -->

  </li> <!-- /.events-item -->
</template>

<script>
export default {
  props: [ 'eventsArchiveUrl' ],
  data() {
    return {
      date: new Date(),
      events: [],
      isRunning: false,
    };
  },
  mounted() {
    const _this = this;
    _this.getEvents();
  },
  methods: {
    displayDate: function() {
      const _this = this;

      const nth = function(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1:  return 'st';
          case 2:  return 'nd';
          case 3:  return 'rd';
          default: return 'th';
        }
      }

      const day = _this.date.getDate();
      const month = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'][_this.date.getMonth()];

      return month + ' ' + day + nth( day ) + ', ' + _this.date.getFullYear();
    },
    getEvents: function() {
      const _this = this;

      if ( ! _this.isRunning ) {
        _this.isRunning = true;

        fetch( site_info.nav_events_url + '?date=' + _this.formatDate() )
          .then( function( response ) { return response.json(); } )
          .then( function( data ) {
            _this.events = data;
            _this.isRunning = false;
          } );
      }
    },
    formatDate: function() {
      const _this = this;
      let month = '' + (_this.date.getMonth() + 1);
      let day = '' + _this.date.getDate();
      const year = _this.date.getFullYear();

      if ( month.length < 2 ) {
        month = '0' + month;
      }

      if ( day.length < 2 ) {
        day = '0' + day;
      }

      return [year, month, day].join('-');
    },
  },
  watch: {
    date: function( newValue, oldValue ) {
      const _this = this;

      if ( _this.isRunning ) {
        _this.date = oldValue
      } else {
        _this.getEvents();
      }
    }
  },
  computed: {
  },
};
</script>
